import store from '@/store'
import { SSharedAuth } from '@/services'

/* eslint-disable-next-line */
export default async (_to, _from, next) => {
  if (!store.getters['auth/check'] && store.getters['auth/token']) {
    await SSharedAuth.getCurrentUser().then(({ data }) => {
      store.dispatch('auth/fetchUserSuccess', data)
    }).catch(() => {
      store.dispatch('auth/fetchUserFailure')
    })
  }

  next()
}
